import { Stack } from '@mui/material';
import { type ElementType, type ReactNode } from 'react';

interface StandardPageLayoutProps {
  /**
   * The action bar to display at the top of the page. Use ActionBar component.
   */
  actionBar: ReactNode;
  /**
   * The body of the page.
   * Compose with LeftNavigationPageBody, CrudPageBody, or StandardPageBody.
   */
  children: ReactNode;
  component?: ElementType;
}

/**
 * Our standard page layout with 100% height and overflow hidden.
 */
export function StandardPageLayout(props: StandardPageLayoutProps) {
  const { children, actionBar, component } = props;

  return (
    <Stack marginTop={1} height="100%" overflow="hidden" component={component ?? Stack}>
      {actionBar}
      {children}
    </Stack>
  );
}
